import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
//import { GridOptions, ColDef, RowNode, RefreshCellsParams, RedrawRowsParams } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, RowNode, GridApi, RedrawRowsParams } from 'ag-grid-community';

import { Subscription, Subject, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { ActionCellRendererComponent } from '../ag-grid/action-cell-renderer.component';

import { FinancialAssuranceService } from '../../services/financial-assurance.service';
import { OrganizationComplianceDetails, FinancialComplianceSearchSpec } from "../../models/organization.model";
import { FinancialAssuranceSummary } from '../../models/financialAssurance.model';
import { GridFormatterService } from '../../services/grid-formatter.service';
import { IBooleanFilterParams, AgGridBooleanFilterComponent } from '../ag-grid/filters/boolean-filter.component';
import { ButtonRendererComponent } from "../ag-grid/button-renderer.component";
import { OrganizationService } from "../../services/organization.service";

@Component({
    selector: 'fa-list',
    templateUrl: './fa-list.component.html',
    standalone: false
})
export class FinancialAssuranceListComponent implements OnInit {
    @Input() gridAriaLabel: string;


    @Output() companyClicked: EventEmitter<string> = new EventEmitter<string>();



    colBondingProvided: ColDef = {
        headerClass: "wrapped",
        headerName: 'Bonding Provided',
        headerTooltip: 'Bonding Provided',
        tooltipValueGetter: this.formatterService.formatCurrency('bondingProvided'),
        field: 'bondingProvided',
        filter: "agNumberColumnFilter",
        filterParams: this.formatterService.defaultNumberFilterParams,
        valueFormatter: this.formatterService.formatCurrency('bondingProvided'),
        minWidth: 110
    }

    colBondingRequired: ColDef = {
        headerClass: "wrapped",
        headerName: 'Bonding Required',
        headerTooltip: 'Bonding Required',
        tooltipValueGetter: this.bondingRequiredFormatter(this),
        field: 'requiredBonding',
        filter: "agNumberColumnFilter",
        filterParams: this.formatterService.defaultNumberFilterParams,
        valueFormatter: this.bondingRequiredFormatter(this),
        minWidth: 110
    }

    colInsuranceProvided: ColDef = {
        headerClass: "wrapped",
        headerName: 'Insurance Provided',
        headerTooltip: 'Insurance Provided',
        tooltipValueGetter: this.formatterService.formatCurrency('insuranceProvided'),
        field: 'insuranceProvided',
        filter: "agNumberColumnFilter",
        filterParams: this.formatterService.defaultNumberFilterParams,
        valueFormatter: this.formatterService.formatCurrency('insuranceProvided'),
        minWidth: 110
    }

    colInsuranceRequired: ColDef = {
        headerClass: "wrapped",
        headerName: 'Insurance Required',
        headerTooltip: 'Insurance Required',
        tooltipValueGetter: this.formatterService.formatCurrency('requiredInsurance'),
        field: 'requiredInsurance',
        filter: "agNumberColumnFilter",
        filterParams: this.formatterService.defaultNumberFilterParams,
        valueFormatter: this.formatterService.formatCurrency('requiredInsurance'),
        minWidth: 110
    }

    colName: ColDef = {
        headerClass: "wrapped",
        headerName: 'Company',
        headerTooltip: 'Company',
        tooltipField: 'name',
        field: 'name',
        cellRenderer: ActionCellRendererComponent,
        cellRendererParams: {
            textField: 'name',
            action: this.showDetail(this)
        },
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        minWidth: 125
    };

    colStatus: ColDef = {
        headerClass: "wrapped",
        headerName: 'Compliance Status',
        headerTooltip: 'Compliance Status',
        tooltipValueGetter: this.statusFormatter(this),
        valueGetter: (obj) => this.isCompliant(obj.data),
        valueFormatter: this.statusFormatter(this),
        filter: AgGridBooleanFilterComponent,
        filterParams: {
            falseValueDisplayFormat: 'Non-compliant',
            trueValueDisplayFormat: 'Compliant',
            isInServerSideFilterMode: false,
        } as IBooleanFilterParams,
        minWidth: 110
    }

    colCalculate: ColDef = {
        headerClass: "wrapped",
        headerName: "",
        headerTooltip: "",
        cellRenderer: ButtonRendererComponent,
        cellRendererParams: {
            action: (obj) => this.recalculate(obj),
            buttonText: "Recalculate"
        },
        minWidth: 125,
        maxWidth: 125
    };


    ownerTypeColumn: ColDef = {
        headerClass: "wrapped",
        headerName: "Owner Type",
        headerTooltip: "Owner Type",
        tooltipValueGetter: this.formatOwnerType(),
        valueGetter: this.formatOwnerType(),
        minWidth: 110
    }

    lastUpdated: ColDef = {
        headerClass: "wrapped",
        headerName: "Compliance Last Updated",
        headerTooltip: "Compliance Last Updated",
        field: 'lastUpdatedDate',
        valueGetter: this.formatterService.formatDate('lastUpdatedDate', 'MM/dd/yyyy, h:mm a'),
        tooltipValueGetter: this.formatterService.formatDate('lastUpdatedDate', 'MM/dd/yyyy, h:mm a'),
        filter: false,
        minWidth: 150
    }

    data: Subject<OrganizationComplianceDetails[]> = new Subject<OrganizationComplianceDetails[]>();
    dataObservable: Observable<OrganizationComplianceDetails[]> = this.data.asObservable();
    rows: OrganizationComplianceDetails[];
	gridOptions: GridOptions;
	gridApi?: GridApi
    showingDetail: boolean = false;
    subscriptions: Subscription = new Subscription();

    public colDefs = [this.colName, this.ownerTypeColumn, this.colStatus, this.colBondingRequired, this.colBondingProvided, this.colInsuranceRequired, this.colInsuranceProvided, this.lastUpdated, this.colCalculate];

    constructor(
        public router: Router,
        public service: FinancialAssuranceService,
        private formatterService: GridFormatterService,
        private organizationService: OrganizationService,
        public currencyPipe: CurrencyPipe) {
    }

    ngOnInit() {
        let spec = {
            organizationIds: [],
            includeHistoricOwnerNumbers: false,
            organizationId: "",
            historicOwnerNumber: "",
            exactMatch: false
        } as FinancialComplianceSearchSpec;
        let obs$ = this.organizationService.getComplianceData(spec)
            .pipe(tap((summaries: OrganizationComplianceDetails[]) => {
                this.rows = summaries;
                this.data.next(this.rows);
        }));
        let subs$ = obs$.subscribe(
            () => { },
            (error) => { console.error(error); }
        );
        this.subscriptions.add(subs$);
        this.gridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.colDefs);
        this.gridOptions.getRowClass = (params: any) => {
            if (!this.isCompliant(params.data)) return 'red';
		};
		this.gridOptions.onGridReady = (params) => {
			this.gridApi = params.api;
		};
        this.gridOptions.headerHeight = 50;
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    formatOwnerType() : any {
        return (obj) => {
            let returnValue: string = "";
            if (obj.data) {
                if (obj.data["isBrineHauler"] != null) {
                    if (obj.data["isBrineHauler"] == true) returnValue = "Brine Hauler";
                }
                if (obj.data["isWellOwner"] != null) {
                    if (obj.data["isWellOwner"] == true) {
                        if (returnValue.length > 0) {
                            returnValue += ", ";
                        }
                        returnValue += "Well Owner";
                    }
                }
            }
            if (returnValue.length === 0) returnValue = "N/A";
            return returnValue;
        }
    }

    isCompliant(summary: OrganizationComplianceDetails): boolean {
        return summary.isBondingCompliant && summary.isInsuranceCompliant;
    }

    recalculate(data: any): void {
        let details = <OrganizationComplianceDetails>data;
        this.gridApi.setGridOption("loading", true);
        let updates$ = this.organizationService.updateCompliance(details.orgId).pipe()
            .subscribe(
                (result: OrganizationComplianceDetails) => {
                    let index = this.rows.findIndex(d => d.orgId == result.orgId);
                    let nodes: RowNode[] = [];
                    if (index != -1) {
                        this.rows.splice(index, 1, result);
                        this.gridApi.forEachNode(n => {
                            if (n.data != null) {
                                let obj = <OrganizationComplianceDetails>n.data;
                                if (obj.orgId == result.orgId) {
                                    n.data = result;
                                    nodes.push(n as RowNode<any>);
                                }
                            }
                        })
                    }
                    this.data.next(this.rows);
                    this.gridApi.setGridOption("loading", false);
                    this.gridApi.redrawRows(<RedrawRowsParams>{ rowNodes: nodes });
                },
                (error) => {
                    console.error();
                    this.gridApi.setGridOption("loading", false);
                }
        );
        this.subscriptions.add(updates$);
    }

    resizeColumns(): void {
        setTimeout(() => this.gridApi?.sizeColumnsToFit(), 0);
    }

    showDetail(component: FinancialAssuranceListComponent) {
        return (obj) => {
            component.companyClicked.emit(obj.data.orgId);
        }
    }

    public bondingRequiredFormatter(component: FinancialAssuranceListComponent) {
        return (obj) => component.currencyPipe.transform(obj.data.requiredBonding);
    }

    public statusFormatter(component: FinancialAssuranceListComponent) {
        return (obj) => component.isCompliant(obj.data) ? 'Compliant' : 'Non-compliant';
    }

}
